import React from 'react';
import { ButtonLabel, ButtonsDiv, Container, Content, Divider, SelectArea } from './styles';
import Button from 'components/Buttom/Button';
import { useHistory } from 'react-router';

const HandleOrganizer = (): JSX.Element => {
  const history = useHistory();
  const path = window.location.pathname;
  return (
    <Container>
      <Content>
        <SelectArea>
          <h2>Selecione o que gostaria de acordo com seu tipo de perfil:</h2>
          <ButtonsDiv>
            <ButtonLabel>
              <Button
                text={'CRIAR NOVA CONTA'}
                onClick={() => {
                  if (path.includes('organizer')) {
                    history.push('/signup/admin', { profile: 1 });
                  }
                }}
              />
              <label htmlFor="">Criação de novo usuário Organizador de Excursão</label>
            </ButtonLabel>
            <Divider />
            <ButtonLabel>
              <Button
                text={'ACESSAR MINHA CONTA'}
                onClick={() => {
                  if (path.includes('organizer')) {
                    history.push('/login/admin', { profile: 1 });
                  }
                }}
              />
              <label htmlFor="">Acesse sua conta, histórico ou crie novas excursões</label>
            </ButtonLabel>
          </ButtonsDiv>
        </SelectArea>
      </Content>
    </Container>
  );
};

export default HandleOrganizer;
